import { Route } from '@angular/router';

export const siteLayoutRoutes: Route[] = [];
